import {
  subscriptionStatus,
  businessNature,
  ownership,
  nameSort,
  quickFilter,
  lineLevelSort,
  benefitStatus
} from '../../../../utils/espSortNFilter/types'
// Action Types
const SORTBY_NAME_A_TO_Z = "SORTBY_NAME_A_TO_Z"
const SORTBY_NAME_Z_TO_A = "SORTBY_NAME_Z_TO_A"
const SORTBY_LINE_LEVEL_LOW_TO_HIGH = "SORTBY_LINE_LEVEL_LOW_TO_HIGH"
const SORTBY_LINE_LEVEL_HIGH_TO_LOW = "SORTBY_LINE_LEVEL_HIGH_TO_LOW"
const SUBSCRIPTION_STATUS_FILTER = "SUBSCRIPTION_STATUS_FILTER"
const OWNERSHIP_FILTER = "OWNERSHIP_FILTER"
const BUSINESS_NATURE_FILTER = "BUSINESS_NATURE_FILTER"
const BENEFIT_STATUS_FILTER = "BENEFIT_STATUS_FILTER"
const RESET_FILTER_N_SORT = "RESET_FILTER_N_SORT"
const APPLYING_CHANGE = "APPLYING_CHANGE"
const APPLIED_CHANGE = "APPLIED_CHANGE"
const APPLY_DRAFT = "APPLY_DRAFT"
const UPDATE_SEARCH_QUERY = "UPDATE_SEARCH_QUERY"
const APPLY_SEARCH_QUERY = "APPLY_SEARCH_QUERY"
const UPDATE_QUICK_FILTER = "UPDATE_QUICK_FILTER"
const APPLY_QUICK_FILTER = "APPLY_QUICK_FILTER"
const CLEAR_QUICK_FILTER = "CLEAR_QUICK_FILTER"

// Actions
export const sortByNameAtoZ = () => ({
  type: SORTBY_NAME_A_TO_Z,
  payload: nameSort.A_TO_Z
})

export const sortByNameZtoA = () => ({
  type: SORTBY_NAME_Z_TO_A,
  payload: nameSort.Z_TO_A
})

export const sortByLineLevelLowToHigh = () => ({
  type: SORTBY_LINE_LEVEL_LOW_TO_HIGH,
  payload: lineLevelSort.LOW_TO_HIGH
})

export const sortByLineLevelHighToLow = () => ({
  type: SORTBY_LINE_LEVEL_HIGH_TO_LOW,
  payload: lineLevelSort.HIGH_TO_LOW
})

export const subscriptionStatusFilter = (statuses) => ({
  type: SUBSCRIPTION_STATUS_FILTER,
  payload: statuses
})

export const ownershipFilter = (ownerships) => ({
  type: OWNERSHIP_FILTER,
  payload: ownerships
})

export const businessNatureFilter = (businessNatures) => ({
  type: BUSINESS_NATURE_FILTER,
  payload: businessNatures
})

export const benefitStatusFilter = (benefitStatuses) => ({
  type: BENEFIT_STATUS_FILTER,
  payload: benefitStatuses
})

export const applyingChange = () => ({
  type: APPLYING_CHANGE
})

export const changeApplied = () => ({
  type: APPLIED_CHANGE
})

export const resetFilterNSort = () => ({
  type: RESET_FILTER_N_SORT
})

export const applyFilterNSort = () => async (dispatch) => {
  dispatch(applyingChange())
  dispatch({
    type: APPLY_DRAFT
  })
  dispatch(changeApplied())
}

export const updateSearchQuery = (query) => ({
  type: UPDATE_SEARCH_QUERY,
  payload: query
})

export const applySearchQuery = (query) => ({
  type: APPLY_SEARCH_QUERY,
  payload: query
})

export const updateQuickFilter = (key) => ({
  type: UPDATE_QUICK_FILTER,
  payload: key
})

export const applyQuickFilter = () => async (dispatch, getState) => {
  const key = getState().sortNFilterState.quickFilter
  console.log("Quick Filter: ", key)
  dispatch(resetFilterNSort())
  switch(key) {
    case quickFilter.ALL:
      break
    case quickFilter.SUBSCRIPTION_DEFAULT:
      dispatch(subscriptionStatusFilter([subscriptionStatus.OVERDUE]))
      break
    case quickFilter.SERVICE_SCHEDULED:
      dispatch(benefitStatusFilter([benefitStatus.SCHEDULED]))
      break
    case quickFilter.SERVICE_AVAILABLE:
      dispatch(benefitStatusFilter([benefitStatus.AVAILABLE]))
      break
    default:
      break
  }
  dispatch(applyFilterNSort())
  
  dispatch({
    type: APPLY_QUICK_FILTER
  })
} 

export const clearQuickFilter = () => async (dispatch) => {
  dispatch({
    type: CLEAR_QUICK_FILTER
  })
}

export const applyOnlyDefaultSubscription = () => async (dispatch) => {
  dispatch(resetFilterNSort())
  dispatch(subscriptionStatusFilter([subscriptionStatus.OVERDUE]))
  dispatch(applyFilterNSort())
}

// Reducers
const baseState = {
  //sortBy: null,
  sortBy: lineLevelSort.HIGH_TO_LOW,
  filter: {
    subscriptionStatus: [subscriptionStatus.ACTIVE, subscriptionStatus.OVERDUE],
    businessNature: [businessNature.ABO, businessNature.APC],
    ownership: [ownership.SELF, ownership.OTHER],
    benefitStatus: [benefitStatus.EXPIRED, benefitStatus.AVAILABLE, benefitStatus.COMPLETED, benefitStatus.IN_REVIEW, benefitStatus.SCHEDULED]
  },
  fullTextSearch: "",
}

const initialState = {
  draft: {
    ...baseState
  },
  applied: {
    ...baseState
  },
  isApplying: false,
  quickFilter: quickFilter.ALL,
}

const sortNFilterState = (state = initialState, action) => {
  switch (action.type) {
    case SORTBY_NAME_A_TO_Z:
      return {
        ...state,
        draft: {
          ...state.draft,
          sortBy: action.payload
        }
      }
    case SORTBY_NAME_Z_TO_A:
      return {
        ...state,
        draft: {
          ...state.draft,
          sortBy: action.payload
        }
      }
    case SORTBY_LINE_LEVEL_LOW_TO_HIGH:
      return {
        ...state,
        draft: {
          ...state.draft,
          sortBy: action.payload
        }
      }
    case SORTBY_LINE_LEVEL_HIGH_TO_LOW:
      return {
        ...state,
        draft: {
          ...state.draft,
          sortBy: action.payload
        }
      }
    case SUBSCRIPTION_STATUS_FILTER:
      return {
        ...state,
        draft: {
          ...state.draft,
          filter: {
            ...state.draft.filter,
            subscriptionStatus: action.payload
          }
        }
      }
    case BUSINESS_NATURE_FILTER:
      return {
        ...state,
        draft: {
          ...state.draft,
          filter: {
            ...state.draft.filter,
            businessNature: action.payload
          }
        }
      }
    case OWNERSHIP_FILTER:
      return {
        ...state,
        draft: {
          ...state.draft,
          filter: {
            ...state.draft.filter,
            ownership: action.payload
          }
        }
      }
    case BENEFIT_STATUS_FILTER:
      return {
        ...state,
        draft: {
          ...state.draft,
          filter: {
            ...state.draft.filter,
            benefitStatus: action.payload
          }
        }
      }
    case APPLYING_CHANGE:
      return {
        ...state,
        isApplying: true
      }
    case APPLIED_CHANGE:
      return {
        ...state,
        isApplying: false
      }
    case APPLY_DRAFT:
      return {
        ...state,
        applied: {
          ...state.draft,
          fullTextSearch: ""
        }
      }
    case UPDATE_SEARCH_QUERY:
      return {
        ...state,
        draft: {
          ...state.draft,
          fullTextSearch: action.payload
        }
      }
    case APPLY_SEARCH_QUERY:
      return {
        ...state,
        applied: {
          ...state.draft,
          fullTextSearch: action.payload
        }
      }
    case UPDATE_QUICK_FILTER:
      return {
        ...state,
        quickFilter: action.payload
      }
    case APPLY_QUICK_FILTER:
      return {
        ...state,
        applied: {
          ...state.draft
        }
      }
    case CLEAR_QUICK_FILTER:
      return {
        ...state,
        quickFilter: ""
      }
    case RESET_FILTER_N_SORT:
      return {
        ...initialState,
        quickFilter: state.quickFilter
      }
    default:
      return state
  }
}

export default {
  sortNFilterState
}
